<template lang="pug">
  div
    .parallax.mt-6
      v-row(align="center" style="height:100%")
        v-col(cols="12" align="center")
          .display-2.justify-center(style="background-color: #D2AE89") Men's Ministry
    v-container()
      v-row(justify="center" )
        v-col(cols="12")
          v-img.float-md-left.mr-4.mb-4.elevation-6( src="../../assets/img/9772850_orig.png" width="50%" "min-width"="300" ) 
          div.headline About Us
          .body-1 We are a growing ministry that seeks to serve the church with financial support and encouragement. We exist to reach out and connect with the male identified members of the church and increase our active membership.
          br
          .title Current Ministry
          .body-1 Our goals for 2018-19 are as follows:
          ul
            li To increase the number of meetings where we hold heartfelt round table discussions, that deal with some of the serious issues, that are important to the men of the church.
            li To occasionally invite knowledgeable guests from outside the church to speak to and interact with our discussion groups
            li To provide funds to assist the Youth Department with outings for our young people
            li To engage in activities with the Youth at the East Oakland Sports Center and forge ties with other churches and community organizations.
            li To develop a structure for providing support for our older brothers who live alone, and to mentor one another
            li To finish painting the Church hallway
          .title Contacts:
          a.pl-6(href="" ) Elder Clarence Holmes
          br
          a.pl-6(href="" ) Minister Terry Wells
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.v-application
  .display-2, .display-3, p
    font-family Montserrat, 'san-serif' !important

.parallax
  background-image url('../../assets/img/background/Natural-Wood.jpg')
  height 300px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size 100%
  color white

@media screen and (max-width: 950px)
  .parallax
    background-attachment scroll
</style>
